import { createSelector } from 'reselect'
import { pendingSelector } from 'api/selectors'

export const scanticketStateSelector = state => state.scanticket

export const scanticketLocationSelector = createSelector(scanticketStateSelector, scanticket => scanticket.location)

export const scanticketLocationPendingSelector = createSelector(pendingSelector, pending => pending.scanTicketLocation)

export const scanticketPromoCodePendingSelector = createSelector(
    pendingSelector,
    pending => pending.reedemScanticketPromo
)

export const getScanTicketPendingSelector = createSelector(pendingSelector, pending => pending.getScanTicket)
export const buyScanTicketPendingSelector = createSelector(pendingSelector, pending => pending.buyScanticket)

export const scanticketTicketSelector = createSelector(scanticketStateSelector, scanticket =>
    scanticket.promo ? { ...scanticket.promo, isPromo: true } : scanticket.ticket
)

export const scanticketTotalPriceSelector = createSelector(scanticketTicketSelector, ticket => ticket?.amountDue)

export const scanticketPromoSelector = createSelector(scanticketStateSelector, scanticket => scanticket.promo)
